const IconArrowRight = (): JSX.Element => {
  return (
    <>
      <path
        d="M21.5459 13.7318L14.7959 20.4818C14.5846 20.6931 14.2979 20.8118 13.9991 20.8118C13.7002 20.8118 13.4135 20.6931 13.2022 20.4818C12.9908 20.2704 12.8721 19.9838 12.8721 19.6849C12.8721 19.386 12.9908 19.0994 13.2022 18.888L18.0312 14.0608H4.25C3.95163 14.0608 3.66548 13.9423 3.4545 13.7313C3.24353 13.5203 3.125 13.2342 3.125 12.9358C3.125 12.6375 3.24353 12.3513 3.4545 12.1403C3.66548 11.9294 3.95163 11.8108 4.25 11.8108H18.0312L13.2041 6.98083C12.9927 6.76949 12.874 6.48284 12.874 6.18396C12.874 5.88507 12.9927 5.59843 13.2041 5.38708C13.4154 5.17574 13.7021 5.05701 14.0009 5.05701C14.2998 5.05701 14.5865 5.17574 14.7978 5.38708L21.5478 12.1371C21.6527 12.2417 21.7359 12.3661 21.7926 12.503C21.8493 12.6399 21.8784 12.7866 21.8782 12.9348C21.8781 13.083 21.8486 13.2297 21.7916 13.3664C21.7346 13.5032 21.6511 13.6274 21.5459 13.7318Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconArrowRight;
